(() => {
  const setModal = (root, open) => {
    const modal = root.querySelector('[data-shopping-bag-modal]');
    const toggle = root.querySelector('[data-shopping-bag-toggle]');
    modal.hidden = !open;
    modal.setAttribute('aria-hidden', String(!open));
    toggle.setAttribute('aria-expanded', String(open));

    if (open) modal.querySelector('[role="dialog"]').focus();
  };

  document.addEventListener('change', (event) => {
    const root = event.target.closest('[data-shopping-bag-option]');
    if (!root || !event.target.matches('[data-shopping-bag-toggle]')) return;
    const selected = event.target.checked;
    const error = root.querySelector('[data-shopping-bag-error]');
    error.hidden = true;
    const sync = (checked) => {
      document.querySelectorAll('[data-shopping-bag-option]').forEach((option) => {
        const toggle = option.querySelector('[data-shopping-bag-toggle]');
        toggle.checked = checked;
        option.querySelector('[data-shopping-bag-property]').value = checked ? 'Yes' : '';
        setModal(option, checked && selected && option === root);
      });
    };
    const disable = (disabled) => {
      document.querySelectorAll('[data-shopping-bag-toggle]').forEach((toggle) => { toggle.disabled = disabled; });
    };
    sync(selected);
    document.documentElement.style.overflow = selected ? 'hidden' : '';
    disable(true);
    fetch(routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify({ attributes: { 'Shopping Bag': selected ? 'Yes' : '' } })
    }).then((response) => {
      if (!response.ok) throw new Error('Unable to save shopping bag');
    }).catch(() => {
      sync(!selected);
      document.documentElement.style.overflow = '';
      error.hidden = false;
    }).finally(() => disable(false));
  });

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-shopping-bag-close]');
    if (!closeButton) return;

    const root = closeButton.closest('[data-shopping-bag-option]');
    setModal(root, false);
    document.documentElement.style.overflow = '';
    root.querySelector('[data-shopping-bag-toggle]').focus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-shopping-bag-modal]:not([hidden])').forEach((modal) => {
      const root = modal.closest('[data-shopping-bag-option]');
      setModal(root, false);
      document.documentElement.style.overflow = '';
      root.querySelector('[data-shopping-bag-toggle]').focus();
    });
  });
})();
